import { useState, useEffect, useRef } from 'react'
import PageMeta from '../components/page-meta'

const FAQ_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
        {
            "@type": "Question",
            "name": "How old does my baby have to be to have a hand and foot cast taken?",
            "acceptedAnswer": { "@type": "Answer",
                "text": "Any age — casts can be taken from birth right up to adult." }
        },
        {
            "@type": "Question",
            "name": "What is the youngest baby you have cast?",
            "acceptedAnswer": { "@type": "Answer", "text": "2 days old." }
        },
        {
            "@type": "Question",
            "name": "Have I left it too late if my baby is several months old?",
            "acceptedAnswer": { "@type": "Answer",
                "text": "No — six to 24 month olds often have lovely chubby hands and feet, and preschool children are a great age to cast too." }
        },
        {
            "@type": "Question",
            "name": "Can you take hand and foot impressions of toddlers?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes." }
        },
        {
            "@type": "Question",
            "name": "How do I book a casting appointment?",
            "acceptedAnswer": { "@type": "Answer",
                "text": "Contact Sue via Facebook, Instagram, email (info@myminiprints.co.uk), or phone (07771 754144). Appointments can usually be booked within 2 weeks." }
        }
    ]
}

const MAP_SRC = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2476.096144695516!2d0.4374133153575158!3d51.639764308838096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8c1083cd800ad%3A0x45b46401b5ba36e0!2sMy+Mini+Prints+Baby+Hand+and+Feet+Casts+%2F+Impressions+%2F+Essex!5e0!3m2!1sen!2suk!4v1524419118996&key=AIzaSyD1o7NvVFOVOD3xurnrq70cxvCKnPOBkLw"
const MAP_STYLE = {"borderTop": "0 solid", "borderBottom": "0", "borderLeft": "0 solid", "borderRight": "0", "overflow": "scroll", "boxShadow": "2 1 2 #0c0c0c"}

export default function HowToBook() {
    const [isDesktop, setIsDesktop] = useState(null)
    const [mapVisible, setMapVisible] = useState(false)
    const mapRef = useRef(null)

    useEffect(() => {
        const mq = window.matchMedia('(min-width: 768px)')
        setIsDesktop(mq.matches)
        const handler = (e) => setIsDesktop(e.matches)
        mq.addEventListener('change', handler)
        return () => mq.removeEventListener('change', handler)
    }, [])

    useEffect(() => {
        const el = mapRef.current
        if (!el) return
        if (!('IntersectionObserver' in window)) {
            setMapVisible(true)
            return
        }
        const observer = new IntersectionObserver(
            ([entry]) => { if (entry.isIntersecting) { setMapVisible(true); observer.disconnect() } },
            { rootMargin: '200px' }
        )
        observer.observe(el)
        return () => observer.disconnect()
    }, [])

    return <>
        <PageMeta
            title="How to Book"
            description="Book your baby hand and foot casting appointment at My Mini Prints in Billericay, Essex. Contact Sue via phone, email, Facebook, or Instagram."
            canonical="/howtobook"
            jsonLd={FAQ_SCHEMA}
        />

            <div className="container">

                <br />
                    <div className="card shadow">
                        <h1 className="card-header h1 display-4" style={{"backgroundColor": "#DCE774", "color": "#504E51"}}>How to Book</h1>
                    </div>
                <br />

                <div className="card mx-auto p-1 shadow" style={{"width" : "100%"}}>
                    <div className="card-body">
                        <p className="card-text">
                        I have a home studio in Billericay that I work from, and you are welcome to come and have a look at the selection of example casts and frames that I keep in my studio  with no obligation to buy.  If you have any questions, would like to come and view my products, or wish to book an appointment please get in touch with me - my contact details are at the bottom of every page on this website.
                        <br />
                        <br />
                        I can be contacted via Facebook, Instagram, email, or phone to make an appointment and can usually book you a time within the next 2 weeks.
                        <br />
                        <br />
                        On the day of the appointment I know how difficult it is to plan when you have a little one, so please feel free to feed your young baby or change a nappy during your appointment if needed.  You will have plenty of time to view the example frames, discuss options, decide on what you would like, and - of course - take the hand and/or feet impressions.
                        <br />
                        <br />
                        When you do place an order, I require a £40 deposit per frame at the time of taking the impressions with the balance due when the product is ready for collection approximately 8 weeks later.  There can be some flexibility in the options up to the point where I start the work on the frame and - if you want a photo mounted in the frame - you can send me your chosen photos at a later date.  Please note that late decisions on options or sending photos may delay the completion of your frame beyond the estimated 8 weeks.
                        </p>
                    </div>

                </div>
                <br />
                <div className="card mx-auto p-1 shadow" style={{"width" : "100%"}}>
                    <h2 className="card-header">How to Find Us</h2>
                    <div className="card-body">
                        <h3 className="text-center">Sue Tarbard</h3>
                        <h3 className="text-center">8 Smythe Close, Billericay, </h3>
                        <h3 className="text-center">Essex, CM11 1SF</h3>
                        <br />
                        <br />
                        <br />
                        <div ref={mapRef} className="container" style={{"display" : "flex", "justifyContent" : "center"}}>
                        {isDesktop !== null && mapVisible && (
                            <iframe
                                className="mx-auto"
                                title="GoogleMaps"
                                src={MAP_SRC}
                                width={isDesktop ? 600 : 280}
                                height={450}
                                frameBorder="0"
                                style={MAP_STYLE}
                                allowFullScreen
                                loading="lazy"
                            />
                        )}
                        </div>
                        <br></br>
                        <br></br>
                    </div>

                </div>
                <br></br>


            <br></br>
            </div>

    </>
}
